import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'
import { employeeContextFilterInput } from '../graphql/filter-inputs'

export const useEmployeesQuery = ({
  username,
  refetchOnWindowFocus = false
}) => {
  return useQuery({
    queryKey: QUERY_KEYS.employeesByUsername(username),
    queryFn: async () => {
      // query spaces by owner
      // query corresponding partners for employees
      const items = await query({
        query: 'spacesByOwner',
        variables: { owner: username, filter: employeeContextFilterInput }
      })

      const partners = await Promise.all(
        items.map((s) =>
          query({
            query: 'getTrimmedPartner',
            variables: { id: s.partner_id },
            options: { origin: 'getPartner' }
          })
        )
      )

      return items.map((s) => ({
        ...s,
        partner: partners.find(({ id }) => id === s.partner_id)
      }))
    },
    refetchOnWindowFocus,
    enabled: !!username
  })
}
